import { Box, Typography, Switch } from '@mui/material';
import { useCallback } from 'react';
import { isFilterAIAwaitingResponseEnabled } from './state';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { aiBotUpgradeModalOpenAtom } from '../../../../../ai-bot/state';
import AiAwaitingReplyImg from '../../../../../../shared/assets/img/ai-awaiting-reply-no-bg.png';
import { aiFeaturePermissionAtom } from '../../chat-input/state';

const AiFilteringToggle = () => {
  const [isAiEnabled, setIsAiEnabled] = useAtom(isFilterAIAwaitingResponseEnabled);
  const setAiBotUpgradeModalOpen = useSetAtom(aiBotUpgradeModalOpenAtom);
  const aiFeaturePermission = useAtomValue(aiFeaturePermissionAtom);

  const handleToggle = useCallback(
    async (checked: boolean) => {
      if (!aiFeaturePermission?.permissions?.chat_ai_awaiting_response) {
        setAiBotUpgradeModalOpen({ open: true, step: 4 });
        return;
      }
      setIsAiEnabled(checked);
    },
    [aiFeaturePermission]
  );

  return (
    <Box
      sx={{
        borderBottom: '1px solid #E0E0E0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'start',
        padding: '14px 7px 14px 12px',
        cursor: 'pointer',
        gap: '16px',
      }}
      onClick={() => handleToggle(!isAiEnabled)}
    >
      <Box sx={{ display: 'flex', gap: '10px' }}>
        <Box
          sx={{
            minWidth: '20px',
            maxWidth: '20px',
          }}
        >
          <img src={AiAwaitingReplyImg} style={{ width: '100%' }} />
        </Box>
        <Box>
          <Typography sx={{ fontWeight: 500, fontSize: 14, lineHeight: '120%', color: '#2d2d2d' }}>
            AI filtering {isAiEnabled ? 'enabled' : 'disabled'}
          </Typography>
          <Typography sx={{ fontWeight: 500, fontSize: 12, lineHeight: '120%', color: '#7a7a7a', marginTop: '2px' }}>
            {isAiEnabled
              ? `Only showing chats where customer is truly waiting for a reply`
              : `Showing all chats without filtering chats with closing statements`}
          </Typography>
        </Box>
      </Box>
      <Switch checked={isAiEnabled} size="small" />
    </Box>
  );
};

export default AiFilteringToggle;
